import React from 'react'

export default function Logo() {
  return <img src='/img/logo.png' alt='Logotipo Intelecto' />
}
